import Axios from 'axios';

const BASE_URL = '/api/classes';


export default {

    getAll() {
        return Axios.get(BASE_URL);
    },

    add(data) {
        return Axios.post(BASE_URL, data);
    },

    update(data) {
        return Axios.put(BASE_URL  +'/'+ data.id, data);
    },

    delete(id) {
        return Axios.delete(BASE_URL +'/'+ id);
    },

    myclasses() {
        return Axios.post(BASE_URL  +'/'+ "myclasses");
    },

    promoclasses() {
      return Axios.post(BASE_URL  +'/'+ "promoclasses");
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/classes.js